function cov_2ji3wpi50w() {
    var path = "/opt/buildhome/repo/packages/kg-portal/src/js/components/views/Maintenance.tsx";
    var hash = "adbbf9077d4c1027667f5b6a7e871052eb103877";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/opt/buildhome/repo/packages/kg-portal/src/js/components/views/Maintenance.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 5,
                    column: 30
                },
                end: {
                    line: 29,
                    column: 1
                }
            },
            "1": {
                start: {
                    line: 6,
                    column: 15
                },
                end: {
                    line: 6,
                    column: 41
                }
            },
            "2": {
                start: {
                    line: 8,
                    column: 1
                },
                end: {
                    line: 28,
                    column: 3
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 5,
                        column: 30
                    },
                    end: {
                        line: 5,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 5,
                        column: 49
                    },
                    end: {
                        line: 29,
                        column: 1
                    }
                },
                line: 5
            }
        },
        branchMap: {},
        s: {
            "0": 0,
            "1": 0,
            "2": 0
        },
        f: {
            "0": 0
        },
        b: {},
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "adbbf9077d4c1027667f5b6a7e871052eb103877"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        cov_2ji3wpi50w = function () {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_2ji3wpi50w();
import * as React from 'react';
import { useTranslation } from 'react-i18next';
cov_2ji3wpi50w().s[0]++;
const Maintenance = () => {
    cov_2ji3wpi50w().f[0]++;
    const { t } = (cov_2ji3wpi50w().s[1]++, useTranslation(['Common']));
    cov_2ji3wpi50w().s[2]++;
    return React.createElement("div", {
        id: "maintenance"
    }, React.createElement("div", {
        className: "page-content"
    }, React.createElement("p", null, React.createElement("strong", null, t('WE_WILL_BE_BACK_SOON'))), React.createElement("p", null, t('MAINTENANCE_MESSAGE_PART_1')), React.createElement("p", null, t('MAINTENANCE_MESSAGE_PART_2'), ' ', React.createElement("a", {
        href: "tel:877-208-2767"
    }, "877-208-2767"), "."), React.createElement("a", {
        href: "https://support.vapor.io/",
        target: "_blank",
        rel: "noreferrer"
    }, "https://support.vapor.io/")));
};
export default Maintenance;
